import instance from '@/service/instance';
import { AxiosPromise} from 'axios'

const resource: string = '/warmup';

export default {
  list(token: string): AxiosPromise<any> {
    return instance.get(`${resource}/`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};
